import { StyleSheet } from 'aphrodite';
import { brandSecondary } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	// Original styles
	body: {
		marginBottom: 30,
	},
	container: {
		minWidth: 460,
	},
	footer: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'flex-end',
		gap: 12,
	},
	header: {
		color: brandSecondary,
		fontSize: 18,
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	searchFieldDropDownContent: {
		width: 464,
	},
	content: {
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: 'column',
		gap: 12,
		minHeight: 100,
	},
});
